/*
  FormattedMessages.js - FormattedMessages for TableSearcher Component
*/

// NPM MODULES
import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedMessages = {
  quickReport: (
    <FormattedMessage
      id="Global.ErrorsTableSearcher"
      defaultMessage="Quick Report:"
    ></FormattedMessage>
  ),
  activityBetween: (
    <FormattedMessage
      id="Global.ErrorsActivityBetween"
      defaultMessage="Activity Between:"
    ></FormattedMessage>
  ),
  todayText: (
    <FormattedMessage id="Global.TodayText" defaultMessage="For Today Only" />
  ),
  yesterdayText: (
    <FormattedMessage
      id="Global.YesterdayText"
      defaultMessage="Since Yesterday"
    />
  ),
  hoursText: (
    <FormattedMessage id="Global.HoursText" defaultMessage="Last 24 hours" />
  ),
  weekText: (
    <FormattedMessage id="Global.WeekText" defaultMessage="For the Last Week" />
  ),
  fortnightText: (
    <FormattedMessage
      id="Global.FortnightText"
      defaultMessage="For the Last Fortnight"
    />
  ),
  monthText: (
    <FormattedMessage
      id="Global.MonthText"
      defaultMessage="For the Last Month (30 Days)"
    />
  ),
  threeMonthText: (
    <FormattedMessage
      id="Global.ThreeMonthText"
      defaultMessage="For the Last 3 Months (90 Days)"
    />
  ),
  yearText: (
    <FormattedMessage
      id="Global.YearText"
      defaultMessage="For the Last Year (365 Days)"
    />
  ),
  customText: (
    <FormattedMessage id="Global.customText" defaultMessage="Custom Range" />
  ),
  nextWeekText: (
    <FormattedMessage
      id="Global.NextWeekText"
      defaultMessage="For the Next Week"
    />
  ),
  nextFortnightText: (
    <FormattedMessage
      id="Global.NextFortnightText"
      defaultMessage="For the Next Fortnight"
    />
  ),
  nextMonthText: (
    <FormattedMessage
      id="Global.NextMonthText"
      defaultMessage="For the Next Month (30 Days)"
    />
  ),
  nextThreeMonthText: (
    <FormattedMessage
      id="Global.NextThreeMonthText"
      defaultMessage="For the Next 3 Months (90 Days)"
    />
  ),
  nextYearText: (
    <FormattedMessage
      id="Global.NextYearText"
      defaultMessage="For the Next Year (365 Days)"
    />
  ),
  searchButton: (
    <FormattedMessage
      id="Global.SearchButton"
      defaultMessage="Search"
    ></FormattedMessage>
  ),
};

export default FormattedMessages;
